import { render, staticRenderFns } from "./SideStats.vue?vue&type=template&id=0a9a008c&scoped=true"
import script from "./SideStats.vue?vue&type=script&lang=js"
export * from "./SideStats.vue?vue&type=script&lang=js"
import style0 from "./SideStats.vue?vue&type=style&index=0&id=0a9a008c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9a008c",
  null
  
)

export default component.exports